﻿var vm;

(function () {
    'use strict';
    var controllerId = 'eirReportCtrl';
    angular
    .module('app.controllers')
    .controller(controllerId, eirReportCtrl)

    eirReportCtrl.$inject = ['common', 'datacontext', '$http', '$scope', '$stateParams'];

    function eirReportCtrl(common, datacontext, $http, $scope, $stateParams) {        
        vm = this;
        vm.isBusy = false;        
        vm.EIRId = $stateParams.EIRId;
        vm.EIRNo = $stateParams.EIRNo;
        vm.LanguageId = $stateParams.LanguageId;
        //TODO: La linea comentada es la última versión, pero entender bien el cambio para utilizarla
        vm.UrlLogoOrganization = $stateParams.UrlLogoOrganization;
        //vm.EirReportName = $stateParams.EirReportName.replace(/TransDepot.Reports/g, "TDP.ReportLibrary");

        var config = common.config;
        //var path = config.basePaths.Base_Path_Resources + 'ReportProvider';

        function init() {
            var divElement = angular.element(document.querySelector('#header'));
            divElement.remove();

            common.activateController([])
                .then(function (data) {
                    $("#reportViewer").telerik_ReportViewer({
                        scaleMode: "SPECIFIC",
                        scale: 1.0,
                        //TODO: Utilizar la versión mas reciente, pero entender porque cambio serviceUrl
                        //templateUrl: "ReportViewer/templates/telerikReportViewerTemplate-9.2.15.930.html",
                        serviceUrl: common.config.basePaths.Report_Path_Resources,
                        templateUrl: "ReportViewer/templates/telerikReportViewerTemplate-10.1.16.615.html",
                        //serviceUrl: pathReport,
                        reportSource: {
                            report: "TDP.ReportLibrary.ReporteEIR, TDP.ReportLibrary",
                            parameters: {
                                EIRId: vm.EIRId,
                                LanguageId: vm.LanguageId,
                                eirNo: vm.EIRNo,
                                logo: vm.UrlLogoOrganization
                            }
                        }
                    });
            });           
        }
        init();
    }

})();